<div class="page-wrapper">
    <form class="table-wrapper p-4" style="border-radius: 10px;" [formGroup]="formGroup" (ngSubmit)="submit()">
        <div class="d-flex align-items-end gap-3">
            <div class="field">
                <label class="mb-0 required">Verification Type</label>
                <ng-select [items]="types" [closeOnSelect]="true" [searchable]="true" [hideSelected]="false"
                    bindLabel="title" bindValue="value" placeholder="Select Type" formControlName="verificationType"
                    class="ng-select control"> </ng-select>
                <!-- <app-error-message [form]="formGroup" controlName="operationLga"></app-error-message> -->
            </div>

            <div class="field">
                <label>Unique ID.</label>
                <input formControlName="value" maxlength="30" class="form-control" placeholder="Enter ID" />
            </div>


            <button class="custom-btn-primary"  [disabled]="formGroup.invalid">Verify</button>
        </div>


    </form>
</div>